import { AfterViewInit, Injectable, OnInit } from '@angular/core';
import { MarketplaceOrderStatus } from '../../command-center/models/marketplace-order.model';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';
import { PointStoreProductOrderService } from '../../marketplace/agent-side/services/point-store-product-order.service';
import { PointStoreProductEditService } from '../../marketplace/admin/services/point-store-product-edit.service';
@Injectable({
    providedIn: "root",
})
export class CxoneOrderManagementService {
    pspos = null;
    localizationStrings: Map<string, string> = new Map<string, string>();
    statusData: any[] = [];
    gridApi = null;
    constructor(
        private cvLocalizationService: CVLocalizationService,
        private pointStoreProductOrderService: PointStoreProductOrderService,
        private pointStoreProductEditService: PointStoreProductEditService,
    ) {
        this.pspos = this.pointStoreProductOrderService.pointStoreProductOrderObj;
    }

    async getLocalizationStrings() {
        this.localizationStrings = await this.cvLocalizationService.GetSection('Order_Management');
        this.loadStatusData();
    }

    getLocalizationString(key: string, defaultValue: string): string {
        return this.localizationStrings.has(key) ? this.localizationStrings.get(key) : defaultValue;
    }

    loadStatusData() {
        this.statusData = [
            {
                id: MarketplaceOrderStatus.Processing,
                name: this.getStatusName(MarketplaceOrderStatus.Processing),
                iconPath:
                    "../App_Themes/CXone/icons/gamification/order-management/processing.svg#processing",
            },
            {
                id: MarketplaceOrderStatus.InTransit,
                name: this.getStatusName(MarketplaceOrderStatus.InTransit),
                iconPath:
                    "../App_Themes/CXone/icons/gamification/order-management/in-transit.svg#in-transit",
            },
            {
                id: MarketplaceOrderStatus.Shipped,
                name: this.getStatusName(MarketplaceOrderStatus.Shipped),
                iconPath:
                    "../App_Themes/CXone/icons/gamification/order-management/shipped.svg#shipped",
            },
            {
                id: MarketplaceOrderStatus.ReadyForPickup,
                name: this.getStatusName(MarketplaceOrderStatus.ReadyForPickup),
                iconPath:
                    "../App_Themes/CXone/icons/gamification/order-management/pick-up.svg#pick-up",
            },
            {
                id: MarketplaceOrderStatus.Complete,
                name: this.getStatusName(MarketplaceOrderStatus.Complete),
                iconPath:
                    "../App_Themes/CXone/icons/gamification/order-management/completed.svg#completed",
            },
            {
                id: MarketplaceOrderStatus.Cancelled,
                name: this.getStatusName(MarketplaceOrderStatus.Cancelled),
                iconPath:
                    "../App_Themes/CXone/icons/gamification/order-management/cancelled.svg#cancelled",
            },
        ];
    }

    getStatusName(status: MarketplaceOrderStatus): string {
        switch (status) {
            case MarketplaceOrderStatus.InTransit:
                return this.getLocalizationString(
                    "In_Transit",
                    "In Transit"
                );
            case MarketplaceOrderStatus.ReadyForPickup:
                return this.getLocalizationString(
                    "Ready_For_Pickup",
                    "Ready for Pick-up"
                );
            case MarketplaceOrderStatus.Complete:
                return this.getLocalizationString(
                    "Completed",
                    "Completed"
                );
            case MarketplaceOrderStatus.Shipped:
                return this.getLocalizationString(
                    "Shipped",
                    "Shipped"
                );
            case MarketplaceOrderStatus.Cancelled:
                return this.getLocalizationString(
                    "Cancelled",
                    "Cancelled"
                );
            case MarketplaceOrderStatus.Created:
            case MarketplaceOrderStatus.Processing:
            default:
                return this.getLocalizationString(
                    "Processing",
                    "Processing"
                );
        }
    }

    getStatusById(id: MarketplaceOrderStatus) {
        return this.statusData.find((status) => status.id === id);
    }

    async onOrderUpdated(e) {
        this.pointStoreProductOrderService.pointStoreProductOrderObj.opc =
            "orders";
        this.pspos.validateCompleteFlag = false;
        this.pspos.validateCompleteFlagResult = false;
        this.pspos.validateCancelledFlag = false;
        this.pspos.validateCancelledFlagResult = false;

        // Don't allow to cancel orders with completed products
        const containsCompletedProducts = e.oldValue.ProductsCollection.some(
            (product) =>
                product._PointStoreProductOrderedDTO.ProductStatus === 4
        );

        const editOrder = (validateFlag, validateFlagResult) => {
            this.pspos[validateFlag] = true;
            this.pspos[validateFlagResult] = true;
            this.pspos.originalPointStoreProductOrder = e.oldValue;
            this.pointStoreProductOrderService.EditPointStoreProductAdminOrderCxOne(
                e.newValue
            );
        };

        if (
            e.newValue.OrderStatus === 4 &&
            e.oldValue.OrderStatus !== 4 &&
            e.oldValue.OrderStatus !== 5
        ) {
            editOrder("validateCompleteFlag", "validateCompleteFlagResult");
        } else if (
            e.newValue.OrderStatus === 5 &&
            e.oldValue.OrderStatus !== 5 &&
            e.oldValue.OrderStatus !== 4
        ) {
            editOrder("validateCancelledFlag", "validateCancelledFlagResult");

            setTimeout(() => {
                //Added to update products' quantities in MarketPlace Management
                if (
                    this.pointStoreProductEditService.pointStoreProductEditObj
                        .collection.isLoaded
                ) {
                    this.pointStoreProductEditService.pointStoreProductEditObj.collection.isLoaded =
                        false;
                }
                this.pointStoreProductEditService.LoadPointStoreProducts();
            }, 500);
        } else if (
            e.oldValue.OrderStatus !== 5 &&
            e.oldValue.OrderStatus !== 4
        ) {
            this.pspos.originalPointStoreProductOrder = e.oldValue;
            this.pointStoreProductOrderService.EditPointStoreProductAdminOrderCxOne(
                e.newValue
            );
        }
        this.pointStoreProductOrderService.pointStoreProductOrderObj.opc = "";
    }

    //Todo: Implement notes functionality
}
